import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { Permission } from '../../../features/auth';

export const Route = createFileRoute('/_auth/case-schedule')({
  staticData: {
    title: 'pages.caseSchedule.title',
    description: 'pages.caseSchedule.description',
  },
  beforeLoad: async ({ context }) => {
    const {isAuthenticated, hasPermission, isAdmin } = context.auth;
    if (!isAuthenticated) throw redirect({ to: '/' });
    if (!hasPermission(Permission.OR_NURSE) && !isAdmin()) {
      throw redirect({ to: '/403' });
    }
  },
  component: CaseScheduleLayout,
});

function CaseScheduleLayout() {
  return <Outlet />;
}














